export const DATASET_POLICY_META = {
    L1: {
        text: 'L1 通用业务数据',
        color: 'green',
        summary: '全员默认只读，owner 保留读写权限。',
    },
    L2: {
        text: 'L2 部门敏感',
        color: 'orange',
        summary: '同一一级部门默认只读，跨部门访问由 owner 审批。',
    },
    L3: {
        text: 'L3 红线区',
        color: 'red',
        summary: '仅 owner 和明确授权的白名单人员可访问。',
    },
}

export const DATASET_IMPORT_MODE_META = {
    snapshot_replace: '全量快照替换',
    append: '增量追加',
    upsert: '按主键更新或新增',
}

export const DATASET_UPDATE_FREQUENCY_META = {
    daily: '每天',
    weekly: '每周',
    monthly: '每月',
    quarterly: '每季度',
    irregular: '不定期',
}

export function getDatasetPolicyMeta(level) {
    return DATASET_POLICY_META[String(level || '').toUpperCase()] || DATASET_POLICY_META.L1
}

export function isSystemManagedDatasetGrant(record, datasetProject) {
    if (!datasetProject || !record) return false
    return record.systemManaged === true
        || record.systemManaged === 1
        || record.systemManaged === '1'
        || record.grantSource === 'system_default'
}

export function buildProjectAuthorizationGrants(
    selectedUserIds,
    users,
    datasetProject,
    permissionTypes = {},
) {
    const records = new Map((users || []).map(item => [String(item.userId), item]))
    return (selectedUserIds || []).map(userId => {
        const record = records.get(String(userId)) || {}
        const preserveSystemPermission = isSystemManagedDatasetGrant(record, datasetProject)
        const selectedPermission = permissionTypes[String(userId)] || record.permissionType
        return {
            userId: String(userId),
            permissionType: record.isOwner
                ? 'readwrite'
                : (preserveSystemPermission
                ? (record.permissionType || 'readonly')
                : (selectedPermission === 'readwrite' ? 'readwrite' : 'readonly')),
        }
    })
}

export function normalizeDatasetSettings(detail) {
    const source = detail || {}
    return {
        sensitivityLevel: String(source.sensitivityLevel || 'L1').toUpperCase(),
        ownerDepartmentId: source.ownerDepartmentId,
        defaultImportMode: source.defaultImportMode || 'snapshot_replace',
        updateFrequency: source.updateFrequency || 'irregular',
        updateFrequencyConfig: source.updateFrequencyConfig || null,
        timezone: source.timezone || 'Asia/Shanghai',
        gracePeriodHours: source.gracePeriodHours === undefined || source.gracePeriodHours === null
            ? 24 : Number(source.gracePeriodHours),
    }
}

export function formatDatasetFieldType(field) {
    const item = field || {}
    const type = item.dataType || '-'
    if (type === 'string' && item.dataLength) {
        return `${type}(${item.dataLength})`
    }
    if (type === 'decimal' && item.numericPrecision) {
        return `${type}(${item.numericPrecision},${item.numericScale || 0})`
    }
    return type
}
